import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _deprecatedBreakpoint, _objectSpread2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/** @deprecated */
export var DeprecatedRuntimeBreakpoints;

(function (DeprecatedRuntimeBreakpoints) {
  DeprecatedRuntimeBreakpoints["DEFAULT"] = "default";
  DeprecatedRuntimeBreakpoints["DESKTOP"] = "desktop";
  DeprecatedRuntimeBreakpoints["LARGE_DESKTOP"] = "large_desktop";
  DeprecatedRuntimeBreakpoints["TABLET"] = "tablet";
  DeprecatedRuntimeBreakpoints["MOBILE_PORTRAIT"] = "mobile_portrait";
})(DeprecatedRuntimeBreakpoints || (DeprecatedRuntimeBreakpoints = {}));

var deprecatedBreakpointsToRange = (_deprecatedBreakpoint = {}, _defineProperty(_deprecatedBreakpoint, DeprecatedRuntimeBreakpoints.DEFAULT, {}), _defineProperty(_deprecatedBreakpoint, DeprecatedRuntimeBreakpoints.LARGE_DESKTOP, {
  minWidth: 1440
}), _defineProperty(_deprecatedBreakpoint, DeprecatedRuntimeBreakpoints.DESKTOP, {
  minWidth: 768
}), _defineProperty(_deprecatedBreakpoint, DeprecatedRuntimeBreakpoints.TABLET, {
  minWidth: 768,
  maxWidth: 1024
}), _defineProperty(_deprecatedBreakpoint, DeprecatedRuntimeBreakpoints.MOBILE_PORTRAIT, {
  maxWidth: 767
}), _deprecatedBreakpoint);
/*  BREAKPOINTS MEDIA QUERY RANGE
 *
 *  |────────────────desktop──────────────── - - - -
 *
 *      mobile       tablet
 *  └────────────│────────────│
 *  0         767/768        1024
 */

export var RuntimeBreakpoint;

(function (RuntimeBreakpoint) {
  RuntimeBreakpoint["DESKTOP"] = "new_desktop";
  RuntimeBreakpoint["TABLET"] = "new_tablet";
  RuntimeBreakpoint["MOBILE"] = "new_mobile";
})(RuntimeBreakpoint || (RuntimeBreakpoint = {}));

export var breakpointsRange = _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, RuntimeBreakpoint.MOBILE, {
  maxWidth: 767
}), _defineProperty(_objectSpread2, RuntimeBreakpoint.TABLET, {
  maxWidth: 1024,
  minWidth: 768
}), _defineProperty(_objectSpread2, RuntimeBreakpoint.DESKTOP, {}), _objectSpread2), deprecatedBreakpointsToRange);
//# sourceMappingURL=index.js.map